import { render, staticRenderFns } from "./AppleAccountForm.vue?vue&type=template&id=ef916912&"
import script from "./AppleAccountForm.vue?vue&type=script&lang=js&"
export * from "./AppleAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports